module.exports = __webpack_public_path__ + "img/menu-slot.447457bb.png";